import { Router } from 'pouter';

import {
  Pages,
} from 'app/constants';

const createRouter = (store) => {
  const router = new Router();
  router.setContext({store});

  router.use('/', (done, location, _context, preRendered) => {
    if (preRendered) return;
    return done({page: Pages.CASH_HOME});
  });

  return router;
};

export default createRouter;
